const Wishlist = {
  key: 'shopify_wishlist',

  get() {
    return JSON.parse(localStorage.getItem(this.key)) || [];
  },

  save(items) {
    localStorage.setItem(this.key, JSON.stringify(items));
    this.updateCount();
    this.updateIcons();
  },

  toggle(handle) {
    let items = this.get();
    if (items.includes(handle)) {
      items = items.filter(i => i !== handle);
    } else {
      items.push(handle);
    }
    this.save(items);
  },

  updateCount() {
    const count = this.get().length;
    document.querySelectorAll('.wishlist-count').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  },

  updateIcons() {
    const items = this.get();
    document.querySelectorAll('.wishlist-btn').forEach(btn => {
      const handle = btn.dataset.handle;
      const isActive = items.includes(handle);
      btn.classList.toggle('active', isActive);
      const svg = btn.querySelector('svg path');
      if (svg) {
        svg.setAttribute('fill', isActive ? 'red' : 'none');
        svg.setAttribute('stroke', isActive ? 'red' : 'currentColor');
      }
    });
  },

  init() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.wishlist-btn');
      if (btn) {
        e.preventDefault();
        this.toggle(btn.dataset.handle);
      }
    });
    this.updateCount();
    this.updateIcons();
  }
};

document.addEventListener('DOMContentLoaded', () => Wishlist.init());